import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import { USER_ANNOUNCEMENT_TYPES_WITH_UI } from 'constants/announcements';
import { useCallback, useEffect, useState } from 'react';
import callAzureFunction from 'utils-ts/call-azure-function';
import handleError from 'utils/handle-error';
import { truncateString } from 'utils/string';
import parse from 'html-react-parser';
import { useSelector } from 'react-redux';
import { USER_TYPE } from '@a1/shared';

const AnnouncementBanner = () => {
  const userData = useSelector((state) => state.user?.data);

  const [announcement, setAnnouncement] = useState(null);
  const [open, setOpen] = useState(false);

  const announcementStyle = USER_ANNOUNCEMENT_TYPES_WITH_UI.find((type) => type.value === announcement?.type);
  const scope = userData?.IsExternalUser ? USER_TYPE.EXTERNAL_USER : userData?.type;

  const getAnnouncementData = useCallback(async () => {
    try {
      const res = await callAzureFunction({
        url: '/user-announcement/get',
        method: 'GET',
        params: { scope }
      });
      setAnnouncement(res.data);
    } catch (error) {
      handleError(error);
    }
  }, [scope]);

  useEffect(() => {
    getAnnouncementData();
  }, [getAnnouncementData]);

  if (!announcement || !announcement?.isEnabled) {
    return null;
  }

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        sx={{ width: '100%', backgroundColor: announcementStyle?.color, py: 0.2 }}
      >
        <Stack direction="row" alignItems="center" gap={2}>
          <Stack direction="row" alignItems="center" gap={0.5}>
            {announcementStyle?.Icon && (
              <Tooltip title={announcementStyle?.label} arrow>
                <announcementStyle.Icon color="white" />
              </Tooltip>
            )}
            <Typography sx={{ color: 'white !important' }}>{truncateString(announcement?.title, 80)}</Typography>
          </Stack>
          <Typography
            variant="caption"
            sx={{ color: 'white !important', textDecoration: 'underline', cursor: 'pointer' }}
            onClick={() => setOpen(true)}
          >
            View announcement details
          </Typography>
        </Stack>
      </Stack>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md">
        <DialogTitle>
          <Stack direction="row" alignItems="center" gap={1} justifyContent="space-between">
            <Typography variant="h3">{announcement?.title}</Typography>
            <Typography variant="caption" sx={{ color: announcementStyle?.color }}>
              ({announcementStyle?.label})
            </Typography>
          </Stack>
        </DialogTitle>
        <DialogContent>{announcement?.message && parse(announcement?.message)}</DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AnnouncementBanner;
